import { Validator } from './Validator';

export type FormErrors = {
	gakkenId: string;
	password: string;
};

export const initialFormErrors: FormErrors = {
	gakkenId: '',
	password: '',
};

export const getErrorMessage = <T>(name: string, value: T): string => {
	const validator = new Validator(value);
	switch (name) {
		case 'gakkenId':
		case 'password':
			return validator.require().end();
		default:
			return '';
	}
};
